import { FC } from "react";
import {
  TOOLTIP_PLACEMENT,
  TOOLTIP_THEME,
  tooltipArrowClassNamesByPlacement,
  tooltipPositionClassNamesByPlacement,
  tooltipPositionWithArrowClassNamesByPlacement,
  tooltipThemeColorClassNamesByTheme,
} from "./constants";
import { twMerge } from "tailwind-merge";

interface Props {
  message: any;
  placement: TOOLTIP_PLACEMENT;
  theme: TOOLTIP_THEME;
  showArrow: boolean;
  isPortaled: boolean;
  tooltipPosition: any;
  tooltipRef: any;
  tooltipClassName?: string;
}

export const TooltipContent: FC<Props> = ({
  message,
  placement,
  theme,
  showArrow,
  isPortaled,
  tooltipPosition,
  tooltipRef,
  tooltipClassName,
}) => {
  return (
    <span
      ref={tooltipRef}
      className={twMerge(
        tooltipThemeColorClassNamesByTheme[theme],
        isPortaled ? "fixed" : "absolute",
        isPortaled
          ? tooltipPosition.class
          : tooltipPositionClassNamesByPlacement[placement],
        !isPortaled &&
          showArrow &&
          tooltipPositionWithArrowClassNamesByPlacement[placement],
        showArrow && tooltipArrowClassNamesByPlacement[placement],
        "transition-all duration-200 rounded px-3 py-2 text-sm scale-0 shadow-sm whitespace-nowrap z-50",
        tooltipClassName
      )}
      style={tooltipPosition.style}
    >
      {message}
    </span>
  );
};
